import { render, staticRenderFns } from "./datalog.vue?vue&type=template&id=42a26d8d&scoped=true"
import script from "./datalog.vue?vue&type=script&lang=js"
export * from "./datalog.vue?vue&type=script&lang=js"
import style0 from "./datalog.vue?vue&type=style&index=0&id=42a26d8d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a26d8d",
  null
  
)

export default component.exports